import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as Styled from "./parameter-input-group.style";
export var ParameterInputGroup = function (_a) {
    var children = _a.children, properties = _a.properties;
    return (_jsxs(Styled.ParameterInputGroup, { separator: properties === null || properties === void 0 ? void 0 : properties.fieldSeparator, children: [(properties === null || properties === void 0 ? void 0 : properties.groupImage) && _jsx("img", { src: properties === null || properties === void 0 ? void 0 : properties.groupImage }), _jsx(Styled.Parameters, { children: children })] }));
};
